import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfig } from '../helpers/app.config';
import { Profile } from '../models/profile.model';

@Injectable({
  providedIn: 'root'
})
export class IdealProfileService {

  constructor(
    private httpClient: HttpClient
  ) { }

  getByBussines(testModelIds, officeId, languageId, clientId = 1) {
    // Para las oficinas HCC es necesario mandar el clientId, para traer las competencias
    // con los nombres personalizados
    let result: any;
    if (clientId !== undefined) {
      result = this.httpClient.get<Profile[]>(AppConfig.settings.API + '/v2/idealprofiles',
        { params: { testModelIds, officeId, languageId, clientId } as any }
      );
    } else {
      result = this.httpClient.get<Profile[]>(AppConfig.settings.API + '/v2/idealprofiles',
        { params: { testModelIds, officeId, languageId } as any }
      );
    }

    return result;
  }

  search(testModelIds: number[], officeId, clientId, page = 1): Observable<Profile[]> {
    return this.httpClient.get<Profile[]>(AppConfig.settings.API + '/v2/idealprofiles',
      { params: { testModelIds, officeId, clientId } as any }
    );
  }

  edit(profileId, editProfile) {
    return this.httpClient.put<Profile>(AppConfig.settings.API + '/idealprofiles/' + profileId, editProfile);
  }

  create(createProfile) {
    return this.httpClient.post<Profile>(AppConfig.settings.API + '/idealprofiles', createProfile);
  }

  delete(id: number, clientId: number) {
    return this.httpClient.delete<boolean>(AppConfig.settings.API + '/idealprofiles/', { body: { id, clientId } });
  }
}
